import { render, staticRenderFns } from "./emergency.vue?vue&type=template&id=7f8d9ab0&scoped=true"
import script from "./emergency.vue?vue&type=script&lang=js"
export * from "./emergency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8d9ab0",
  null
  
)

export default component.exports